/**
 * @Date:   2021-01-05 11:36:31
 * @Filename: request.js
 * @Last modified time: 2021-01-22 06:55:13
 */



import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import $config from '@/config'

let reloadIndex = null
// create an axios instance
const service = axios.create({
  baseURL: $config.API_DOMAIN + $config.BASE_URL, // url = base url + request url
  timeout: 20000, // 超时处理
  validateStatus: status => {
    return status >= 200 && status < 500 // 默认的

  }
})

// 错误提示
const showError = msg => {
  Message({
    message: msg || '未知错误',
    type: 'error',
    duration: 3 * 1000
  })
}

// request 拦截
service.interceptors.request.use(
  config => {
    // 是否开启loading条
    if (config.loading !== false) {
      config.loading = true
      //  NProgress.start()
      //  clearInterval(reloadIndex)
      //  reloadIndex = setInterval(() => {
      //    NProgress.inc(0.01)
      //  }, 100)
    }

    //  if (store.state.user.token) {
    //    // 通过token字段传值，有时候会报跨域，主要可能是后台代码设置允许跨域的请求头字段中没有包括该字段
    //    config.headers['sessionid'] = store.state.user.token;
    //  } else {
    //          config.headers['sessionid'] = '';
    //      }

    // 非get请求 把params赋值给data，方便在api接口统一使用params参数
    if (config.method.toLowerCase() !== 'get') {
      config.data = config.params ? config.params : config.data
      config.params = ''
    }
    return config
  },
  error => {
    // 关闭loading条
    clearInterval(reloadIndex)
    NProgress.done()

    return Promise.reject(error)
  }
)

// response 拦截
service.interceptors.response.use(
  response => {
    // 关闭loading条
    //  clearInterval(reloadIndex)
    //  NProgress.done()

    // 文件流处理
    if (response.status === 200 && response.config.responseType === 'blob') {
      return response
    }
    const res = response.data
    if (response.status === 200) {
      if (res instanceof Array) return res
      if (res.code !== 200) {
        // 非0报错
        switch (res.code) {
          case 401: // 未登录或登录失效
          case 800:
            showError('登录已失效')
            setTimeout(() => {
              store.dispatch('user/logout').then(res => {
                window.$app.$router.replace({ name: 'passportLogin' })
              })
            }, 1000)
            break
          default:
            showError(res.msg)
        }

        return Promise.reject({
          msg: res.msg,
          code: res.code
        })
      } else {
        return res.data
      }
    } else if (response.status === 204) {
      return response;
    } else {
      const msg = `path：${response.data.path} ；statusText：${response.statusText}`
      showError(msg)
      return Promise.reject({
        msg,
        code: response.status
      })
    }
  },
  error => {
    //  clearInterval(reloadIndex)
    //  NProgress.done()

    console.log(error)

    const errorObj = JSON.parse(JSON.stringify(error))
    const res = errorObj.response || {}

    if (res.status === 500) {
      showError(res.data)
    } else {
      showError(error)
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js